import React from 'react';
import * as S from '../ProfileInfo/ProfileInfo.styles';

const SupportInfo = ({supportInfo}) => {
    let arm = supportInfo?.assigned_relationship_manager || null;
    let rmm = supportInfo?.relationship_manager_mobile || null;
    let rme = supportInfo?.relationship_manager_email || null;
    let cs = supportInfo?.customer_support || null;
    let ivrPin = supportInfo?.ivr_pin || null;
    let mdm = supportInfo?.mdm_name || null;
    let mdmEmail = supportInfo?.mdm_email || null;
    return(
        <S.ProfileMainWrap id="supportinfo">
            <S.ProfileInnerWrap>
                <S.ProfileHeadOuterWrap>
                <S.ProfileHeadInnerWrap>
                    <S.HeadMainText>Support Details</S.HeadMainText>
                    {/* <S.HeadSubText>Reach out to us for 24/7 support</S.HeadSubText> */}
                </S.ProfileHeadInnerWrap>
                </S.ProfileHeadOuterWrap>
                <S.ProfileInfoOuterWrap>
                    {cs ?
                        <S.ProfileInfoInnerWrap>
                            <S.InfoTitleWrap>
                                <S.TitleText>24/7 Customer support</S.TitleText>
                            </S.InfoTitleWrap>
                            <S.InfoTextWrap>
                                <S.InfoText>{cs}</S.InfoText>
                            </S.InfoTextWrap>
                        </S.ProfileInfoInnerWrap> : null }
                    {ivrPin ?
                        <S.ProfileInfoInnerWrap>
                            <S.InfoTitleWrap>
                                <S.TitleText>IVR Security Code</S.TitleText>
                            </S.InfoTitleWrap>
                            <S.InfoTextWrap>
                                <S.InfoText>{ivrPin}</S.InfoText>
                                <S.InfoSubText>If you call the Customer Support number from an unregistered mobile number, you need to use the mobile number registered with myPartner and the IVR security code to access your bookings.<br /><br />For example, if your registered mobile number is 9812345678 and your IVR security code is 1234, you will be asked to enter the registered mobile number 9812345678 and IVR Security Code 1234</S.InfoSubText>
                            </S.InfoTextWrap>
                        </S.ProfileInfoInnerWrap> : null }
                    {arm ?
                        <S.ProfileInfoInnerWrap>
                            <S.InfoTitleWrap>
                                <S.TitleText>Assigned relationship manager</S.TitleText>
                            </S.InfoTitleWrap>
                            <S.InfoTextWrap>
                                <S.InfoText>{arm}</S.InfoText>
                            </S.InfoTextWrap>
                        </S.ProfileInfoInnerWrap> : null }
                    {rmm ?
                        <S.ProfileInfoInnerWrap>
                            <S.InfoTitleWrap>
                                <S.TitleText>Relationship manager mobile</S.TitleText>
                            </S.InfoTitleWrap>
                            <S.InfoTextWrap>
                                <S.InfoText>{rmm}</S.InfoText>
                            </S.InfoTextWrap>
                        </S.ProfileInfoInnerWrap> : null }
                    {rme ?
                        <S.ProfileInfoInnerWrap>
                            <S.InfoTitleWrap>
                                <S.TitleText>Relationship manager E-mail</S.TitleText>
                            </S.InfoTitleWrap>
                            <S.InfoTextWrap>
                                <S.InfoText>{rme}</S.InfoText>
                            </S.InfoTextWrap>
                        </S.ProfileInfoInnerWrap> : null }
                    {mdm ?
                        <S.ProfileInfoInnerWrap>
                            <S.InfoTitleWrap>
                                <S.TitleText>Regional Manager</S.TitleText>
                            </S.InfoTitleWrap>
                            <S.InfoTextWrap>
                                <S.InfoText>{mdm}</S.InfoText>
                            </S.InfoTextWrap>
                        </S.ProfileInfoInnerWrap> : null }
                    {mdmEmail ?
                        <S.ProfileInfoInnerWrap>
                            <S.InfoTitleWrap>
                                <S.TitleText>Regional Manager E-mail</S.TitleText>
                            </S.InfoTitleWrap>
                            <S.InfoTextWrap>
                                <S.InfoText>{mdmEmail}</S.InfoText>
                            </S.InfoTextWrap>
                        </S.ProfileInfoInnerWrap> : null }
                </S.ProfileInfoOuterWrap>
            </S.ProfileInnerWrap>
        </S.ProfileMainWrap>
    )
}

export default SupportInfo;